var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-wrapper"},[_c('s-header',{staticClass:"header"}),_c('div',{staticClass:"content d-flex"},[_c('div',{staticClass:"viewport-wrap"},[_c('s-viewport')],1),_c('s-config-pane')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }